/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { type CTAStyling, CTAStylingSchema } from '../shared/cta-styling'
import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Image, ImageSchema } from './image'
import type { RichText } from './rich-text'

/* TypeScript */
export type SliderSlide = {
  id: string
  technicalName?: Maybe<string>
  image: Image
  link?: Maybe<ContentLink>
  linkLabel?: Maybe<string>
  title?: Maybe<RichText>
  fontType?: Maybe<'Ivar' | 'Duplet'>
  titleFontSize?: Maybe<'S' | 'M' | 'L'>
  alignment?: Maybe<'Left' | 'Center'>
  subtitle?: Maybe<RichText>
  ctaStyling?: Maybe<CTAStyling>
}

export type SliderApiProps = {
  technicalName?: Maybe<string>
  slides: SliderSlide[]
  isFullWidth?: Maybe<boolean>
}

/* Schemas */
export const SliderSlideSchema = z.object({
  id: z.string(),
  technicalName: z.nullish(z.string()),
  image: ImageSchema,
  link: z.nullish(ContentLinkSchema),
  linkLabel: z.nullish(z.string()),
  title: z.nullish(LooseRichTextSchema),
  fontType: z.nullish(z.enum(['Ivar', 'Duplet'])),
  titleFontSize: z.nullish(z.enum(['S', 'M', 'L'])),
  alignment: z.nullish(z.enum(['Left', 'Center'])),
  subtitle: z.nullish(LooseRichTextSchema),
  ctaStyling: z.nullish(CTAStylingSchema),
})

export const SliderApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  slides: z.array(SliderSlideSchema),
  isFullWidth: z.nullish(z.boolean()),
})

/* Schemas validation */
type TestSliderProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<SliderApiProps>,
    z.infer<typeof SliderApiPropsSchema>
  >
>
